import api from "../config/axiosConfig";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../utils/utilityFunctions";
import { actionType } from "../utils/constant";
import toast from "react-hot-toast";

export default function useRFIStages({ rfi_id, setStagesReviewData }) {
  const [stagesDetails, setStagesDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state.profile);

  const getRFIStages = useCallback(
    async (rfi_id) => {
      if (!hasPermission(profile?.permissions?.actions, actionType.stage_view))
        return;
      setLoading(true);
      try {
        const response = await api.get(`/api/rfi-stages`, {
          params: {
            rfi_id: rfi_id,
          },
        });
        const dataToSubmit = response.data.map((stage) => {
          if (stage.stage_id === 105) {
            return {
              ...stage,
              current_step: "Inspector",
            };
          }
          return stage;
        });
        setStagesDetails(dataToSubmit);

        // Save all stages to Context for global access (if provided)
        if (setStagesReviewData) {
          setStagesReviewData(dataToSubmit);
        }
      } catch (error) {
        console.error("Error fetching RFI Stages:", error);
      } finally {
        setLoading(false);
      }
    },
    [profile?.permissions?.actions, setStagesReviewData]
  );

  const submitStageAPI = async ({ stage_id }) => {
    if (!stage_id) return;
    if (!hasPermission(profile?.permissions?.actions, actionType.stage_edit)) {
      toast.error("You don't have permission to submit this stage");
      return;
    }
    //API goes below
    return await api
      .post("/api/rfi-stages-workflow/submit-stage", {
        stage_id: stage_id,
      })
      .then(() => {
        return true;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  };

  useEffect(() => {
    if (!rfi_id) return;
    if (!hasPermission(profile?.permissions?.actions, actionType.stage_view))
      return;
    getRFIStages(rfi_id);
  }, [getRFIStages, rfi_id, profile?.permissions?.actions]);

  return { stagesDetails, loading, getRFIStages, submitStageAPI };
}
